import { render } from "./CollectionsStats.vue?vue&type=template&id=3239429b&scoped=true"
import script from "./CollectionsStats.vue?vue&type=script&lang=js"
export * from "./CollectionsStats.vue?vue&type=script&lang=js"

import "./CollectionsStats.vue?vue&type=style&index=0&id=3239429b&lang=stylus&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3239429b"]])

export default __exports__